import { Attachment, Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { AccessoryCategory } from './AccessoryCategoryApi';
import { AccessoryNameOverride } from './AccessoryNameOverrideApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AccessoryRelationAction {
	SHOW = 'show',
	HIDE = 'hide',
}

export interface AccessoryRelation {
	action: AccessoryRelationAction;
	accessories: UUID[];
}

export interface Accessory extends BaseEntity {
	name: string;
	description: string;
	code: string;
	listOrder: number;
	category?: AccessoryCategory;
	image: Attachment | null;
	slug: string;
	collisionLayers: number[];
	relations: AccessoryRelation[];
	nameOverrides: AccessoryNameOverride[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AccessoryApi extends EntityApi<Accessory> {
	constructor() {
		super(ApiQueryKey.accessories);
	}
}

export default new AccessoryApi();
